import { Injectable, NgZone } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  constructor(private ngZone: NgZone) {}

  loading = new BehaviorSubject<Loading>({ isLoading: false, message: '' })
  loading$ = this.loading.asObservable()

  set(loading: Loading) {
    // Defer state change to avoid ExpressionChangedAfterItHasBeenCheckedError
    this.ngZone.run(() => {
      setTimeout(() => {
        this.loading.next(loading)
      }, 0)
    })
  }
}

export class Loading {
  isLoading: boolean
  message: string
  isSilent? = false
}
